var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-table-cell',{staticClass:"text-center"},[(this.bool)?_c('span',{staticClass:"md-tag md-tag-success"},[_vm._v("Active")]):_c('span',{staticClass:"md-tag md-tag-danger"},[_vm._v("Inactive")])])
}
var staticRenderFns = []

export { render, staticRenderFns }